import usePrivateAxios from '@/common/api/usePrivateAxios'
import { MaintenaceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type';
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useMaintenanceWorkflow: (id: string | undefined) => UseQueryResult<MaintenaceWorkflowData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: MaintenaceWorkflowData } }, unknown, MaintenaceWorkflowData>({
    enabled: !!id,
    queryKey: ['maintenanceWorkflow', id],
    queryFn: () => privateAxios.get(`/maintenance/workflows/${id}`),
    select: (data) => data?.data?.data,
  });
}
